import {
  ZitadelGatewayServiceUser,
  ZitadelServiceUser,
  ZitadelUser,
} from "@src/types/user-management";

const userManagementUsersListFieldsSelector = (user: ZitadelUser): string[] => [
  user.email,
  user.given_name,
  user.family_name,
  user.roles.join(" "),
  user.preferred_login_name,
];

const userManagementServiceUsersListFieldsSelector = (
  user: ZitadelServiceUser,
): string[] => [user.username, user.name, user.roles.join(" ")];

const userManagementGatewayServiceUsersListFieldsSelector = (
  user: ZitadelGatewayServiceUser,
): string[] => [user.username, user.name];

const valueMatchesToken = (value: string, token: string) => {
  if (!value) return false;
  return value.toLowerCase().includes(token);
};

const filterBySearchTerms = <T>(
  data: T[],
  searchTerms: string[],
  valueSelector: (user: T) => string[],
): T[] => {
  if (!data || data.length === 0) return [];
  if (!searchTerms || searchTerms.length === 0) return [];

  const normalizedSearchTerms = searchTerms.map((term) => term.toLowerCase());

  return data.filter((user) => {
    const values = valueSelector(user);
    return normalizedSearchTerms.every((term) =>
      values.some((value) => valueMatchesToken(value, term)),
    );
  });
};

export const findFromUsersList = (
  data: ZitadelUser[],
  searchTerms: string[],
): ZitadelUser[] =>
  filterBySearchTerms(data, searchTerms, userManagementUsersListFieldsSelector);

export const findFromServiceUsersList = (
  data: ZitadelServiceUser[],
  searchTerms: string[],
): ZitadelServiceUser[] =>
  filterBySearchTerms(
    data,
    searchTerms,
    userManagementServiceUsersListFieldsSelector,
  );

export const findFromGatewayServiceUsersList = (
  data: ZitadelGatewayServiceUser[],
  searchTerms: string[],
): ZitadelGatewayServiceUser[] =>
  filterBySearchTerms(
    data,
    searchTerms,
    userManagementGatewayServiceUsersListFieldsSelector,
  );
